export const lightTheme = {
	text: "rgb(20, 20, 20)",
	text2: "rgb(55, 55, 55)",
	textInvert: "rgb(245, 245, 245)",
	textInvert2: "rgb(210, 210, 210)",
	primary: "#182978",
	primary2: "#6688CC",
	lightBg: "#8ea3cc",
	bg: "rgb(252, 252, 252)",
	bg2: "rgb(225, 225, 225)",
	shadow: "rgba(20, 20, 20, 0.2)",
};

export const darkTheme = {
	text: "rgb(245, 245, 245)",
	text2: "rgb(210, 210, 210)",
	textInvert: "rgb(20, 20, 20)",
	textInvert2: "rgb(55, 55, 55)",
	primary: "#FB8122",
	primary2: "#ffa058",
	lightBg: "#ffcaa1",
	bg: "#1D2228",
	bg2: "#37414e",
	shadow: "rgba(236, 234, 234, 0.2)",
};
